import {css} from "@emotion/css";
import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {MagazineWriterService} from "../../serverService/magazineService/MagazineWriterService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {
    RaikoAlert, raikoAlertTypes,
    RaikoBaseCardContainer, RaikoGridOneColumn, RaikoSectionContainer, RaikoToggleOutlined,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

const WriterAccessState = () => {

    const {id: writerId} = useParams()

    const service = new MagazineWriterService()
    const loading = new LoadingHelper(useLoadingDispatcher())


    const [banState, setBanState] = useState(false);

    useEffect(() => {
        if (typeof writerId !== 'undefined' && writerId > 0) {
            getWriterAccess();
        }
    }, [writerId]);

    function getWriterAccess() {
        loading.show()
        service.getWriterAccess(writerId)
            .then(response => {
                setBanState(response.enabled)
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function changeManagerEnabledState(state) {
        loading.show()
        service.updateWriterAccess(writerId, state)
            .then(response => {
                if (state) {
                    showSuccessMessage("دسترسی به سامانه برای نویسنده آزاد شد.")
                } else {
                    showWarningMessage("دسترسی نویسنده با موفقیت مسدود شد.")
                }
                console.log("state is ", state)
                setBanState(state)
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    return (

        <RaikoBaseCardContainer className={css`margin-top: 1rem;`}>
            <RaikoSectionContainer title={"مسدود سازی"}>
                <RaikoGridOneColumn>
                    <RaikoAlert
                        title={"لطفا نکات زیر را مورد توجه قرار دهید:"}
                        type={raikoAlertTypes.error}
                        description={["با مسدود سازی نویسنده دسترسی نویسنده به پنل مسدود خواهد شد."]}
                    />
                    <RaikoToggleOutlined
                        labelText={"مسدود سازی"}
                        setChecked={state => {
                            changeManagerEnabledState(!state)
                        }}
                        checked={!banState}
                    />
                </RaikoGridOneColumn>
            </RaikoSectionContainer>
        </RaikoBaseCardContainer>

    )
}

export default WriterAccessState